import { render, staticRenderFns } from "./tm-terms-of-service-page.vue?vue&type=template&id=46d044d0&scoped=true&"
import script from "./tm-terms-of-service-page.vue?vue&type=script&lang=ts&"
export * from "./tm-terms-of-service-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d044d0",
  null
  
)

export default component.exports